import { Component, Vue, Watch } from 'vue-property-decorator'

const MAX_ZOOM_LEVEL = 2
const MIN_ZOOM_LEVEL = 0.5
const ZOOM_STEP = 0.1

@Component
export default class ZoomImage extends Vue {
  protected zoomLevel = 1
  private initialDistance = 0
  private initialZoom = 1

  protected zoomIn(): void {
    this.zoomLevel = Math.min(this.zoomLevel + ZOOM_STEP, MAX_ZOOM_LEVEL)
  }

  protected zoomOut(): void {
    this.zoomLevel = Math.max(this.zoomLevel - ZOOM_STEP, MIN_ZOOM_LEVEL)
  }

  protected handleTouchStart(event: TouchEvent): void {
    if (event.touches.length === 2) {
      this.initialDistance = this.getTouchDistance(event.touches)
      this.initialZoom = this.zoomLevel
    }
  }

  protected handleTouchMove(event: TouchEvent): void {
    if (event.touches.length === 2) {
      event.preventDefault()
      const currentDistance = this.getTouchDistance(event.touches)
      const scale = currentDistance / this.initialDistance
      const newZoom = Math.min(Math.max(this.initialZoom * scale, MIN_ZOOM_LEVEL), MAX_ZOOM_LEVEL)
      this.zoomLevel = newZoom
    }
  }

  private getTouchDistance(touches: TouchList): number {
    const dx = touches[0].clientX - touches[1].clientX
    const dy = touches[0].clientY - touches[1].clientY
    return Math.sqrt(dx * dx + dy * dy)
  }

  @Watch('zoomLevel')
  onZoomLevelChange() {
    // Trigger scroll visibility check after zoom
    this.$nextTick(() => {
      this.checkScrollVisibility()
    })
  }

  protected checkScrollVisibility(): void {
    const element = this.$el.querySelector('.questions__frame') as HTMLElement
    if (element) {
      // Force recalculation of scroll dimensions
      element.style.overflow = 'hidden'
      // Use setTimeout to ensure the style change is processed
      setTimeout(() => {
        element.style.overflow = 'auto'
      }, 0)
    }
  }
}
